<template>
  <div>
    <h3 class="title dw_green--text font-weight-light">
      <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiPoundBox" />
      Existing Tags
    </h3>
    <v-row no-gutters>
      <v-col cols="11">
        <v-text-field
          v-model="search"
          @change="searchExisting"
          @click:clear="search = ''; searchExisting()"
          label="Search Tags"
          :append-icon="mdiMagnify"
          color="dw_green"
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card width="33vw" max-height="50vh" class="pa-2 my-2 existing-list">
      <p v-for="tag of tags" :key="tag" class="grey--text caption mb-1">{{ tag }}</p>
    </v-card>
  </div>
</template>

<script>
import { mdiPoundBox, mdiMagnify } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  name: 'tagList',
  data() {
    return {
      mdiPoundBox,
      mdiMagnify,
      search: '',
      tags: []
    }
  },
  computed: {
    ...mapGetters([
      'tagOptions'
    ])
  },
  mounted() {
    this.tags = this.tagOptions.map((tag) => tag.name);
  },
  methods: {
    searchExisting() {
      this.tags = this.tagOptions.map((tag) => tag.name);
      if (this.search !== '') {
        this.tags = this.tags.filter((tag) => {
          const s = this.search.toLowerCase();
          return tag.toLowerCase().includes(s);
        });
      }
    }
  }
};
</script>

<style scoped>
.existing-list {
  height: inherit;
  overflow-y: scroll;
}
</style>
